import {
  ShopProductListRequest,
  ShopProductListResponse,
  StoreFromSlugResponse,
} from "../interfaces/shop-products.interface";
import { API_ENDPOINTS } from "./api-endpoints";
import { HttpClient } from "./http-client";

export const shopClient = {
  getStoreProducts: (data: ShopProductListRequest) => {
    return HttpClient.post<ShopProductListResponse>(
      API_ENDPOINTS.GET_STORE_PRODUCTS,
      data
    );
  },
  getStoreFromSlug: (slug: string) => {
    return HttpClient.get<StoreFromSlugResponse>(
      `${API_ENDPOINTS.GET_STORE_FROM_SLUG}/${slug}`      
    );
  },
};
